import Axios from 'axios';
import { API_URL } from '../../../DesktopApp';

const getCandidates = async(limit, page) => {
    try{
      const response = await Axios.post(`${API_URL}/desktop/assigncandidates/getallnonassigncandidates`, {limit: limit, page: page});
      return response
    }catch(err){
        return err;
    }
}

const getNonAssignLeadsCount = async (LIMIT, page) =>{
  try{
      const responseCount = await Axios.post(`${API_URL}/desktop/candidates/getAllNonAssignCandidateCount`);
      return responseCount.data[0].canidatenonassigncount;
  }catch(err){
      return err;
  }
}

const unSetCandidate = async(c_id) => {
  try{
    const response = await Axios.post(`${API_URL}/leads/deletelead`, {
      lid: c_id,
    });
    return response;
  }catch(err){
      return err;
  }
};

export {getCandidates, getNonAssignLeadsCount , unSetCandidate}